import { createI18n } from 'vue-i18n';

const messages = {
  'zh-CN': {
    common: { confirm: '确定', cancel: '取消', save: '保存', reset: '恢复默认', close: '关闭' },
    settings: {
      recommendedThemes: '推荐主题',
      recommendedThemesHint: '选择后将完整替换当前配色，仍可继续微调。',
      themeSelected: '当前使用',
      themeSage: '苔绿', themeSageDescription: '柔和、沉静，适合长时间使用的管理后台。',
      themeMustard: '芥黄', themeMustardDescription: '温暖克制，为数据界面增加稳重质感。',
      themeTaupe: '灰棕', themeTaupeDescription: '中性雅致，适合内部协同与运营场景。',
      themeLavender: '雾紫', themeLavenderDescription: '理性柔和，适合专业服务与项目管理。',
      themeDustyBlue: '雾蓝', themeDustyBlueDescription: '清晰可靠，适合政企与数据运营后台。',
      themeRose: '雾粉', themeRoseDescription: '低饱和而温和，保持界面清爽耐看。',
      themePine: '墨绿', themePineDescription: '深沉稳健，适合资源与综合管理场景。',
      quickThemeTitle: '主题配色', quickThemeAdvanced: '高级', quickThemeCustom: '自定义配色',
      quickThemeCancel: '取消', quickThemeApply: '应用',
      title: '设置', appearance: '换肤', language: '语言',
      appearanceTitle: '外观设置', languageTitle: '语言设置',
      languageHint: '选择后立即预览，保存后应用到下次访问。',
      simplified: '简体中文', traditionalHongKong: '繁體中文（香港）',
      brand: '品牌与按钮', surfaces: '页面与表格', text: '文字与交互',
      primaryColor: '品牌主色', independentButton: '按钮使用独立颜色', buttonColor: '主按钮颜色',
      formLabelColor: '表单标签颜色', pageBackground: '页面背景', surfaceBackground: '内容背景',
      headerBackground: '表头背景', headerTextColor: '表头文字', bodyTextColor: '正文文字',
      borderColor: '边框颜色', hoverColor: '悬停行颜色',
      scrollbarColor: '滚动条滑块', contrastWarning: '当前颜色组合对比度偏低，可能影响阅读。', invalidColorWarning: '请输入有效的 HEX 或 RGB 颜色值。',
      savedLocally: '已保存到当前浏览器。'
    },
    header: {
      message: '消息', changePassword: '修改密码', logout: '退出登录',
      accountMenu: '账号菜单', organizationInfo: '组织信息', currentUser: '当前用户',
      company: '单位', department: '部门', notProvided: '未提供',
      logoutConfirmTitle: '退出确认', logoutConfirmMessage: '确定要退出当前登录吗？',
      menuSearch: '搜索菜单或页面', noMenuMatches: '未找到匹配菜单', clearSearch: '清除搜索',
      openNavigation: '打开导航菜单', closeNavigation: '关闭导航菜单',
      expandNavigation: '展开菜单', collapseNavigation: '收起菜单'
    },
    breadcrumb: { currentLocation: '当前位置', home: '首页' },
    table: {
      index: '序号', name: '姓名', age: '年龄', address: '地址', salary: '薪资', gender: '性别', post: '岗位', account: '账号', password: '密码', orderNo: '排序号', remark: '备注', companyName: '公司名称', deptName: '部门名称', phone: '手机号', actions: '操作',
      edit: '编辑', delete: '删除', view: '查看', currentRow: '当前行',
      menuName: '菜单名称', menuType: '菜单类型', menuPath: '菜单路径', tableName: '表名', permissionCode: '权限代码', icon: '图标', enabled: '是否启用', enabledValue: '启用', disabledValue: '停用',
      lazyLoad: '懒加载', loadAll: '一次性加载', reload: '重新加载', totalNodes: '总节点：{count}', loadedNodes: '已加载节点：{count}', visibleNodes: '当前可见节点：{count}',
      contains: '包含', notContains: '不包含', equals: '等于', notEqual: '不等于', startsWith: '开头是', endsWith: '结尾是', blank: '为空', notBlank: '不为空', filter: '筛选...', search: '搜索...', apply: '应用', clear: '清除', noMatches: '无匹配项', and: '且', or: '或'
    },
  },
  'zh-HK': {
    common: { confirm: '確定', cancel: '取消', save: '儲存', reset: '恢復預設', close: '關閉' },
    settings: {
      recommendedThemes: '建議主題',
      recommendedThemesHint: '選擇後會完整替換當前配色，仍可繼續微調。',
      themeSelected: '現正使用',
      themeSage: '苔綠', themeSageDescription: '柔和、沉靜，適合長時間使用的管理後台。',
      themeMustard: '芥黃', themeMustardDescription: '溫暖克制，為數據介面增加穩重質感。',
      themeTaupe: '灰棕', themeTaupeDescription: '中性雅致，適合內部協作與營運場景。',
      themeLavender: '霧紫', themeLavenderDescription: '理性柔和，適合專業服務與專案管理。',
      themeDustyBlue: '霧藍', themeDustyBlueDescription: '清晰可靠，適合政企與數據營運後台。',
      themeRose: '霧粉', themeRoseDescription: '低飽和而溫和，保持介面清爽耐看。',
      themePine: '墨綠', themePineDescription: '深沉穩健，適合資源與綜合管理場景。',
      quickThemeTitle: '主題配色', quickThemeAdvanced: '進階', quickThemeCustom: '自訂配色',
      quickThemeCancel: '取消', quickThemeApply: '套用',
      title: '設定', appearance: '換膚', language: '語言',
      appearanceTitle: '外觀設定', languageTitle: '語言設定',
      languageHint: '選擇後立即預覽，儲存後套用至下次訪問。',
      simplified: '簡體中文', traditionalHongKong: '繁體中文（香港）',
      brand: '品牌與按鈕', surfaces: '頁面與表格', text: '文字與互動',
      primaryColor: '品牌主色', independentButton: '按鈕使用獨立顏色', buttonColor: '主按鈕顏色',
      formLabelColor: '表單標籤顏色', pageBackground: '頁面背景', surfaceBackground: '內容背景',
      headerBackground: '表頭背景', headerTextColor: '表頭文字', bodyTextColor: '正文文字',
      borderColor: '邊框顏色', hoverColor: '懸停列顏色',
      scrollbarColor: '捲動軸滑塊', contrastWarning: '目前顏色組合對比度偏低，可能影響閱讀。', invalidColorWarning: '請輸入有效的 HEX 或 RGB 色彩值。',
      savedLocally: '已儲存至目前瀏覽器。'
    },
    header: {
      message: '訊息', changePassword: '修改密碼', logout: '登出',
      accountMenu: '帳號選單', organizationInfo: '組織資訊', currentUser: '目前使用者',
      company: '單位', department: '部門', notProvided: '未提供',
      logoutConfirmTitle: '登出確認', logoutConfirmMessage: '確定要登出目前帳號嗎？',
      menuSearch: '搜尋選單或頁面', noMenuMatches: '未找到相符選單', clearSearch: '清除搜尋',
      openNavigation: '開啟導覽選單', closeNavigation: '關閉導覽選單',
      expandNavigation: '展開選單', collapseNavigation: '收起選單'
    },
    breadcrumb: { currentLocation: '目前位置', home: '首頁' },
    table: {
      index: '序號', name: '姓名', age: '年齡', address: '地址', salary: '薪資', gender: '性別', post: '崗位', account: '帳號', password: '密碼', orderNo: '排序號', remark: '備註', companyName: '公司名稱', deptName: '部門名稱', phone: '手機號碼', actions: '操作',
      edit: '編輯', delete: '刪除', view: '檢視', currentRow: '目前列',
      menuName: '選單名稱', menuType: '選單類型', menuPath: '選單路徑', tableName: '表名', permissionCode: '權限代碼', icon: '圖示', enabled: '是否啟用', enabledValue: '啟用', disabledValue: '停用',
      lazyLoad: '延遲載入', loadAll: '一次載入', reload: '重新載入', totalNodes: '總節點：{count}', loadedNodes: '已載入節點：{count}', visibleNodes: '目前可見節點：{count}',
      contains: '包含', notContains: '不包含', equals: '等於', notEqual: '不等於', startsWith: '開頭是', endsWith: '結尾是', blank: '為空', notBlank: '不為空', filter: '篩選...', search: '搜尋...', apply: '套用', clear: '清除', noMatches: '無相符項目', and: '且', or: '或'
    },
  },
};

export const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: 'zh-CN',
  fallbackLocale: 'zh-CN',
  messages,
});

export function setAppLocale(locale) {
  i18n.global.locale.value = locale;
}
